import React from "react";
/* import { Link } from "gatsby"; */

const Nav = () => {
  return (
    <nav className=" mt-4 sm:mt-0">
      <ul className="list-reset flex justify-center">
        {/* <li className="mr-6">
          <Link
            to="/acerca-de"
            className="text-blue-darker no-underline hover:text-orange-lightest text-sm"
          >
            Acerca de
          </Link>
        </li> */}
        {/* <li>
          <a
            href="https://www.jandrade.co"
            className="text-blue-darker no-underline hover:text-orange-lightest text-sm"
          >
            Sitio Web JFA
          </a>
        </li> */}
      </ul>
    </nav>
  );
};

export default Nav;
